module.exports = __webpack_public_path__ + "img/222a6cf.png";